import { Button } from 'antd';
import styled from 'styled-components';

const StyledSortButton = styled(Button)`
  border: none !important;
  color: #0078d4;

  &.active {
    color: #ff4d4f !important;
  }
`;

export default StyledSortButton;
